import { eur, num } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Delta } from "@/components/Delta";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

// Categorie di due stagioni a confronto: fatturato e pezzi
export const SeasonCategoryCompare = ({ a, b, nameA, nameB }) => {
  const map = (d) => Object.fromEntries((d?.by_category || []).map((c) => [c.name, c]));
  const ma = map(a);
  const mb = map(b);
  const names = [...new Set([...Object.keys(ma), ...Object.keys(mb)])].sort((x, y) => (ma[y]?.value || 0) - (ma[x]?.value || 0));
  const max = Math.max(1, ...names.map((n) => Math.max(ma[n]?.value || 0, mb[n]?.value || 0)));
  return (
    <Card className="mt-6 overflow-hidden" data-testid="season-category-compare">
      <h3 className="border-b border-border/60 px-6 py-4 font-display text-lg font-semibold">Categorie a confronto <span className="text-sm font-normal text-muted-foreground">{nameA} contro {nameB}</span></h3>
      <Table>
        <TableHeader>
          <TableRow className="hover:bg-transparent">
            <TableHead>Categoria</TableHead>
            <TableHead className="w-[30%]"></TableHead>
            <TableHead className="text-right">Fatturato {nameA}</TableHead>
            <TableHead className="text-right">Fatturato {nameB}</TableHead>
            <TableHead className="text-right">Pezzi {nameA}</TableHead>
            <TableHead className="text-right">Pezzi {nameB}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {names.map((n) => (
            <TableRow key={n} data-testid={`season-compare-cat-${n}`}>
              <TableCell className="text-sm font-medium">{n}</TableCell>
              <TableCell>
                <div className="space-y-1">
                  <div className="h-2 rounded-full bg-primary" style={{ width: `${((ma[n]?.value || 0) / max) * 100}%` }} />
                  <div className="h-2 rounded-full bg-muted-foreground/40" style={{ width: `${((mb[n]?.value || 0) / max) * 100}%` }} />
                </div>
              </TableCell>
              <TableCell className="text-right font-semibold"><div className="flex items-center justify-end gap-2">{eur(ma[n]?.value || 0)}<Delta current={ma[n]?.value || 0} previous={mb[n]?.value || 0} /></div></TableCell>
              <TableCell className="text-right text-muted-foreground">{eur(mb[n]?.value || 0)}</TableCell>
              <TableCell className="text-right text-sm"><div className="flex items-center justify-end gap-2">{num(ma[n]?.units || 0)}<Delta current={ma[n]?.units || 0} previous={mb[n]?.units || 0} /></div></TableCell>
              <TableCell className="text-right text-sm text-muted-foreground">{num(mb[n]?.units || 0)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <p className="flex items-center gap-4 px-6 py-3 text-xs text-muted-foreground">
        <span className="flex items-center gap-1.5"><span className="h-2 w-4 rounded-full bg-primary" />{nameA}</span>
        <span className="flex items-center gap-1.5"><span className="h-2 w-4 rounded-full bg-muted-foreground/40" />{nameB}</span>
      </p>
    </Card>
  );
};
